<script lang="ts">
    import Stats from './Stats/Stats.svelte';
    import Menu from './Menu/Menu.svelte';
    import Profile from './Profile/Profile.svelte';
    import Guide from './Guide/Guide.svelte';

    const TABS = ['profile', 'stats', 'guide', 'contact'] as const;
    type Tab = typeof TABS[number];

    let activeTab = $state<Tab>((localStorage.getItem('activeTab') as Tab) ?? 'profile');

    function changeTab(tab: Tab) {
        activeTab = tab;
        localStorage.setItem('activeTab', tab);
    }
</script>

<div class="d-flex flex-row justify-content-between align-items-center">
    <ul class="nav nav-tabs">
        <li class="nav-item">
            <span class="nav-link" class:active={activeTab === 'profile'} onclick={() => changeTab('profile')}>Налаштування</span>
        </li>
        <li class="nav-item">
            <span class="nav-link" class:active={activeTab === 'stats'} onclick={() => changeTab('stats')}>Статистика</span>
        </li>
        <li class="nav-item">
            <span class="nav-link" class:active={activeTab === 'guide'} onclick={() => changeTab('guide')}>📖 Гайд</span>
        </li>
        <li class="nav-item">
            <span class="nav-link" class:active={activeTab === 'contact'} onclick={() => changeTab('contact')}>Контакти</span>
        </li>
    </ul>
    <Menu />
</div>

<div class="tab-content mt-3 p-3">
    {#if activeTab === 'profile'}
        <Profile />
    {:else if activeTab === 'stats'}
        <Stats />
    {:else if activeTab === 'guide'}
        <Guide />
    {:else if activeTab === 'contact'}
        <p>Інформація для зв'язку...</p>
    {/if}
</div>

<style>
    .nav-link { cursor: pointer; }
</style>
